{
  "Skill": [
    {
      "item_id": "59C08B6D-F8D4-F9DB-81D9-0FD592094C73",
      "item_name": "Balance",
      "item_type": "defensive_skill",
      "variable_name": "balance",
      "essence_used": "22918408-67CC-4093-80E8-BF6FA8915C21"
    },
    {
      "item_id": "24C07918-39D5-4317-A958-BDF68B633A21",
      "item_name": "Fortitude",
      "item_type": "defensive_skill",
      "variable_name": "fortitude",
      "essence_used": "22918408-67CC-4093-80E8-BF6FA8915C21"
    },
    {
      "item_id": "58A62523-2588-452B-876B-61D8ACF3CCED",
      "item_name": "Psyche",
      "item_type": "defensive_skill",
      "variable_name": "psyche",
      "essence_used": "63ABC96E-3804-4E1F-B38D-AABA3237B2D8"
    },
    {
      "item_id": "922C5882-54DE-42D0-A5C8-8118AA1C858E",
      "item_name": "Willpower",
      "item_type": "defensive_skill",
      "variable_name": "willpower",
      "essence_used": "72F93730-134F-4CA2-8FC4-F2915F20CAC6"
    },
    {
      "item_id": "F99172CC-DDEF-48D4-87F8-8B94F0071247",
      "item_name": "Attention",
      "item_type": "innate_skill",
      "variable_name": "attention",
      "essence_used": "72F93730-134F-4CA2-8FC4-F2915F20CAC6"
    },
    {
      "item_id": "397C35B1-76DB-4A45-1468-E53CF797A1A3",
      "item_name": "Empathy",
      "item_type": "innate_skill",
      "variable_name": "empathy",
      "essence_used": "72F93730-134F-4CA2-8FC4-F2915F20CAC6"
    },
    {
      "item_id": "30735770-7440-0C26-5FDF-86C452C0C91D",
      "item_name": "Frighten",
      "item_type": "innate_skill",
      "variable_name": "frighten",
      "essence_used": "22918408-67CC-4093-80E8-BF6FA8915C21"
    },
    {
      "item_id": "F5A23631-F770-1C49-79F0-E8A2B7A6DCAC",
      "item_name": "Influence",
      "item_type": "innate_skill",
      "variable_name": "influence",
      "essence_used": "72F93730-134F-4CA2-8FC4-F2915F20CAC6"
    },
    {
      "item_id": "6E1A31A4-2D30-096B-BEA4-E2A1DC93A583",
      "item_name": "Initiative",
      "item_type": "innate_skill",
      "variable_name": "initiative",
      "essence_used": "22918408-67CC-4093-80E8-BF6FA8915C21"
    },
    {
      "item_id": "28E0D03E-86B3-FDF4-E03A-8DFA1043FE3E",
      "item_name": "Inspection",
      "item_type": "innate_skill",
      "variable_name": "inspection",
      "essence_used": "63ABC96E-3804-4E1F-B38D-AABA3237B2D8"
    },
    {
      "item_id": "64493E62-BCAF-27F1-2B6A-EC84DE328F66",
      "item_name": "Sneak",
      "item_type": "innate_skill",
      "variable_name": "sneak",
      "essence_used": "22918408-67CC-4093-80E8-BF6FA8915C21"
    },
    {
      "item_id": "9F177F51-CDAC-0012-A574-DE1B8B17A55F",
      "item_name": "Excavating",
      "item_type": "gathering_skill",
      "variable_name": "excavating",
      "essence_used": "22918408-67CC-4093-80E8-BF6FA8915C21"
    },
    {
      "item_id": "B3856A19-34AD-D33A-14F1-BBBE79A67DA5",
      "item_name": "Farming",
      "item_type": "gathering_skill",
      "variable_name": "farming",
      "essence_used": "22918408-67CC-4093-80E8-BF6FA8915C21"
    },
    {
      "item_id": "59B5B7EA-38B8-28C7-B74F-182906B4E3D7",
      "item_name": "Fishing",
      "item_type": "gathering_skill",
      "variable_name": "fishing",
      "essence_used": "22918408-67CC-4093-80E8-BF6FA8915C21"
    },
    {
      "item_id": "42D2DDEC-9C0C-E111-BE72-F556B47EDBFE",
      "item_name": "Herbalism",
      "item_type": "gathering_skill",
      "variable_name": "herbalism",
      "essence_used": "22918408-67CC-4093-80E8-BF6FA8915C21"
    },
    {
      "item_id": "964A6407-E371-E6FA-A3FC-4ECDAD3615B7",
      "item_name": "Hunting",
      "item_type": "gathering_skill",
      "variable_name": "hunting",
      "essence_used": "22918408-67CC-4093-80E8-BF6FA8915C21"
    },
    {
      "item_id": "1E875D11-8C3F-53D6-5256-7FF5363FB1E4",
      "item_name": "Locks",
      "item_type": "gathering_skill",
      "variable_name": "locks",
      "essence_used": "22918408-67CC-4093-80E8-BF6FA8915C21"
    },
    {
      "item_id": "B6B008F2-5805-C31F-842F-ED0C16D34484",
      "item_name": "Mining",
      "item_type": "gathering_skill",
      "variable_name": "mining",
      "essence_used": "22918408-67CC-4093-80E8-BF6FA8915C21"
    },
    {
      "item_id": "114E1810-D8A6-72C2-54B8-7EDBC5D43A57",
      "item_name": "Skinning",
      "item_type": "gathering_skill",
      "variable_name": "skinning",
      "essence_used": "22918408-67CC-4093-80E8-BF6FA8915C21"
    },
    {
      "item_id": "27C6E09D-9CD0-41E5-B765-18F096CD8781",
      "item_name": "Architecture",
      "item_type": "knowledge_skill",
      "variable_name": "architecture",
      "essence_used": "63ABC96E-3804-4E1F-B38D-AABA3237B2D8"
    },
    {
      "item_id": "432EF6B0-0DF5-5EA9-33A6-F1BE691772D0",
      "item_name": "Astronomy",
      "item_type": "knowledge_skill",
      "variable_name": "astronomy",
      "essence_used": "63ABC96E-3804-4E1F-B38D-AABA3237B2D8"
    },
    {
      "item_id": "AFF19B47-5E29-B9EA-1CEF-D017C9F440C3",
      "item_name": "Biology",
      "item_type": "knowledge_skill",
      "variable_name": "biology",
      "essence_used": "63ABC96E-3804-4E1F-B38D-AABA3237B2D8"
    },
    {
      "item_id": "432DBB43-005F-88D9-4F25-B5745D5C08D2",
      "item_name": "Civics",
      "item_type": "knowledge_skill",
      "variable_name": "civics",
      "essence_used": "63ABC96E-3804-4E1F-B38D-AABA3237B2D8"
    },
    {
      "item_id": "E38D3E9B-55CE-49EE-272B-C053D3C2E3B9",
      "item_name": "Finance",
      "item_type": "knowledge_skill",
      "variable_name": "finance",
      "essence_used": "63ABC96E-3804-4E1F-B38D-AABA3237B2D8"
    },
    {
      "item_id": "10657AA2-E10A-4C86-A814-B3A24B0CB252",
      "item_name": "Gamesmanship",
      "item_type": "knowledge_skill",
      "variable_name": "gamesmanship",
      "essence_used": "63ABC96E-3804-4E1F-B38D-AABA3237B2D8"
    },
    {
      "item_id": "E023B642-259E-69D7-4E72-334FE0A6EE64",
      "item_name": "Geology",
      "item_type": "knowledge_skill",
      "variable_name": "geology",
      "essence_used": "63ABC96E-3804-4E1F-B38D-AABA3237B2D8"
    },
    {
      "item_id": "58B3E565-2DAB-C967-766E-7D815EF1429B",
      "item_name": "History",
      "item_type": "knowledge_skill",
      "variable_name": "history",
      "essence_used": "63ABC96E-3804-4E1F-B38D-AABA3237B2D8"
    },
    {
      "item_id": "D7F6DF07-296F-B231-3E70-9D6B46575709",
      "item_name": "Law",
      "item_type": "knowledge_skill",
      "variable_name": "law",
      "essence_used": "63ABC96E-3804-4E1F-B38D-AABA3237B2D8"
    },
    {
      "item_id": "258BD584-26FB-F656-D15F-566BE8984551",
      "item_name": "Linguistics",
      "item_type": "knowledge_skill",
      "variable_name": "linguistics",
      "essence_used": "63ABC96E-3804-4E1F-B38D-AABA3237B2D8"
    },
    {
      "item_id": "ABE36CBD-1142-9809-FA05-C7DC4263B43C",
      "item_name": "Magic",
      "item_type": "knowledge_skill",
      "variable_name": "magic",
      "essence_used": "63ABC96E-3804-4E1F-B38D-AABA3237B2D8"
    },
    {
      "item_id": "761600DE-35EB-7B14-5980-F2430FFF85AB",
      "item_name": "Medicine",
      "item_type": "knowledge_skill",
      "variable_name": "medicine",
      "essence_used": "63ABC96E-3804-4E1F-B38D-AABA3237B2D8"
    },
    {
      "item_id": "F259DADA-89E7-F08F-E24C-DA140F84FB36",
      "item_name": "Music",
      "item_type": "knowledge_skill",
      "variable_name": "music",
      "essence_used": "63ABC96E-3804-4E1F-B38D-AABA3237B2D8"
    },
    {
      "item_id": "DEC0A112-9ADC-09D3-0FA7-3A59CFE8C008",
      "item_name": "Navigation",
      "item_type": "knowledge_skill",
      "variable_name": "navigation",
      "essence_used": "63ABC96E-3804-4E1F-B38D-AABA3237B2D8"
    },
    {
      "item_id": "1D2EB61A-67FB-4F6D-FC1B-B5C36357CA6E",
      "item_name": "Planes",
      "item_type": "knowledge_skill",
      "variable_name": "planes",
      "essence_used": "63ABC96E-3804-4E1F-B38D-AABA3237B2D8"
    },
    {
      "item_id": "4D0FF632-CAC9-4714-64B8-43978DD90A7E",
      "item_name": "Religion",
      "item_type": "knowledge_skill",
      "variable_name": "religion",
      "essence_used": "63ABC96E-3804-4E1F-B38D-AABA3237B2D8"
    },
    {
      "item_id": "86BD9ED9-4768-239D-E755-BC198290FDBE",
      "item_name": "Alchemy",
      "item_type": "crafting_skill",
      "variable_name": "alchemy",
      "recipe_name": "alchemy_recipe",
      "recipe_names": [
        "alchemy_recipe",
        "brewing_recipe"
      ],
      "essence_used": "72F93730-134F-4CA2-8FC4-F2915F20CAC6"
    },
    {
      "item_id": "9CC50F9B-B8AD-B180-79BE-C309F1563800",
      "item_name": "Art",
      "item_type": "crafting_skill",
      "variable_name": "art",
      "recipe_name": "art_recipe",
      "recipe_names": [
        "art_recipe"
      ],
      "essence_used": "72F93730-134F-4CA2-8FC4-F2915F20CAC6"
    },
    {
      "item_id": "7229802A-2169-DDD4-6CCB-E755CCFAEB51",
      "item_name": "Cooking",
      "item_type": "crafting_skill",
      "variable_name": "cooking",
      "recipe_name": "cooking_recipe",
      "essence_used": "72F93730-134F-4CA2-8FC4-F2915F20CAC6"
    },
    {
      "item_id": "E77A8B34-F880-E0E2-E6EC-42F4241F4FCC",
      "item_name": "Enchanting",
      "item_type": "crafting_skill",
      "variable_name": "enchanting",
      "recipe_name": "enchanting_recipe",
      "recipe_names": [
        "enchanting_recipe",
        "runeforging_recipe"
      ],
      "essence_used": "72F93730-134F-4CA2-8FC4-F2915F20CAC6"
    },
    {
      "item_id": "B27AC929-722C-685E-E93E-CE38F49FF9BE",
      "item_name": "Glassblowing",
      "item_type": "crafting_skill",
      "variable_name": "glassblowing",
      "recipe_name": "glassblowing_recipe",
      "essence_used": "72F93730-134F-4CA2-8FC4-F2915F20CAC6"
    },
    {
      "item_id": "AFD61488-049C-C7FC-2B72-26CBE7EAEAFD",
      "item_name": "Jewelling",
      "item_type": "crafting_skill",
      "variable_name": "jewelling",
      "recipe_name": "jewelling_recipe",
      "essence_used": "72F93730-134F-4CA2-8FC4-F2915F20CAC6"
    },
    {
      "item_id": "F29D806E-160C-4EC2-923F-AAF1D5CDDB7E",
      "item_name": "Leatherworking",
      "item_type": "crafting_skill",
      "variable_name": "leatherworking",
      "recipe_name": "leatherworking_recipe",
      "recipe_names": [
        "leatherworking_recipe",
        "cobbling_recipe",
        "tanning_recipe"
      ],
      "essence_used": "72F93730-134F-4CA2-8FC4-F2915F20CAC6"
    },
    {
      "item_id": "D7F51670-F6D9-5DD6-11D9-0CDBF35096A0",
      "item_name": "Machining",
      "item_type": "crafting_skill",
      "variable_name": "machining",
      "recipe_name": "machining_recipe",
      "essence_used": "72F93730-134F-4CA2-8FC4-F2915F20CAC6"
    },
    {
      "item_id": "6C3E6964-F138-CA3F-DB99-4BFC7AF3E4FB",
      "item_name": "Masoning",
      "item_type": "crafting_skill",
      "variable_name": "masoning",
      "recipe_name": "masoning_recipe",
      "essence_used": "72F93730-134F-4CA2-8FC4-F2915F20CAC6"
    },
    {
      "item_id": "0A68ECAB-D224-CF73-DB51-761BCFD663FA",
      "item_name": "Smithing",
      "item_type": "crafting_skill",
      "variable_name": "smithing",
      "recipe_name": "smithing_recipe",
      "essence_used": "72F93730-134F-4CA2-8FC4-F2915F20CAC6"
    },
    {
      "item_id": "55565C71-B55B-3D10-9DFB-7C45D95BC724",
      "item_name": "Weaving",
      "item_type": "crafting_skill",
      "variable_name": "weaving",
      "recipe_name": "weaving_recipe",
      "essence_used": "72F93730-134F-4CA2-8FC4-F2915F20CAC6"
    },
    {
      "item_id": "E5347227-42FD-9173-6C81-ADAD3E0ED6ED",
      "item_name": "Woodworking",
      "item_type": "crafting_skill",
      "variable_name": "woodworking",
      "recipe_name": "woodworking_recipe",
      "recipe_names": [
        "woodworking_recipe"
      ],
      "essence_used": "72F93730-134F-4CA2-8FC4-F2915F20CAC6"
    },
    {
      "item_id": "A5B19883-CBDA-EC46-A859-96FF01651278",
      "item_name": "Abolian",
      "item_type": "language_skill",
      "variable_name": "abolian",
      "essence_used": "63ABC96E-3804-4E1F-B38D-AABA3237B2D8"
    },
    {
      "item_id": "B12FE4D0-480A-239A-DAF0-704850F5162D",
      "item_name": "Abyssal",
      "item_type": "language_skill",
      "variable_name": "abyssal",
      "essence_used": "63ABC96E-3804-4E1F-B38D-AABA3237B2D8"
    },
    {
      "item_id": "820AB0A3-F21A-3135-DB75-89DCDF09A9D0",
      "item_name": "Aquan",
      "item_type": "language_skill",
      "variable_name": "aquan",
      "essence_used": "63ABC96E-3804-4E1F-B38D-AABA3237B2D8"
    },
    {
      "item_id": "B1B5365D-2DE0-AA53-A729-AC28BF8C8D52",
      "item_name": "Auran",
      "item_type": "language_skill",
      "variable_name": "auran",
      "essence_used": "63ABC96E-3804-4E1F-B38D-AABA3237B2D8"
    },
    {
      "item_id": "81DADED4-7909-482A-BE32-76887642C172",
      "item_name": "Common",
      "item_type": "language_skill",
      "variable_name": "common",
      "essence_used": "63ABC96E-3804-4E1F-B38D-AABA3237B2D8"
    },
    {
      "item_id": "6EEF7655-4FC7-F5F4-0AB8-C31C31FEEDCD",
      "item_name": "Domir",
      "item_type": "language_skill",
      "variable_name": "domir",
      "essence_used": "63ABC96E-3804-4E1F-B38D-AABA3237B2D8"
    },
    {
      "item_id": "0700727F-6C9E-4631-1140-B57A8E442137",
      "item_name": "Draconic",
      "item_type": "language_skill",
      "variable_name": "draconic",
      "essence_used": "63ABC96E-3804-4E1F-B38D-AABA3237B2D8"
    },
    {
      "item_id": "94D1A00F-4795-B1DD-6981-6CE3364AF1B3",
      "item_name": "Druidic",
      "item_type": "language_skill",
      "variable_name": "druidic",
      "essence_used": "63ABC96E-3804-4E1F-B38D-AABA3237B2D8"
    },
    {
      "item_id": "5C346F0F-D58D-2859-92EB-A347FA56899E",
      "item_name": "Dwarvish",
      "item_type": "language_skill",
      "variable_name": "dwarvish",
      "essence_used": "63ABC96E-3804-4E1F-B38D-AABA3237B2D8"
    },
    {
      "item_id": "42728623-5523-5986-672E-9A9FE5DD35B5",
      "item_name": "Elvish",
      "item_type": "language_skill",
      "variable_name": "elvish",
      "essence_used": "63ABC96E-3804-4E1F-B38D-AABA3237B2D8"
    },
    {
      "item_id": "4A5172E6-6D97-3958-C65B-F0792A660B85",
      "item_name": "Enochian",
      "item_type": "language_skill",
      "variable_name": "enochian",
      "essence_used": "63ABC96E-3804-4E1F-B38D-AABA3237B2D8"
    },
    {
      "item_id": "3098C163-7B26-7757-24F1-129C467D5BDB",
      "item_name": "Gnomish",
      "item_type": "language_skill",
      "variable_name": "gnomish",
      "essence_used": "63ABC96E-3804-4E1F-B38D-AABA3237B2D8"
    },
    {
      "item_id": "6AB76ADB-22BC-904A-7D72-43FDCA112DD1",
      "item_name": "Grel",
      "item_type": "language_skill",
      "variable_name": "grel",
      "essence_used": "63ABC96E-3804-4E1F-B38D-AABA3237B2D8"
    },
    {
      "item_id": "4767BD78-9829-6FC9-BD4A-5855F322CEB7",
      "item_name": "Ignan",
      "item_type": "language_skill",
      "variable_name": "ignan",
      "essence_used": "63ABC96E-3804-4E1F-B38D-AABA3237B2D8"
    },
    {
      "item_id": "22CC3970-0458-63CA-3D69-82A746B9A5CD",
      "item_name": "Nagh",
      "item_type": "language_skill",
      "variable_name": "nagh",
      "essence_used": "63ABC96E-3804-4E1F-B38D-AABA3237B2D8"
    },
    {
      "item_id": "16A53E58-027B-DF11-6AC5-72CA13B6583A",
      "item_name": "Orcish",
      "item_type": "language_skill",
      "variable_name": "orcish",
      "essence_used": "63ABC96E-3804-4E1F-B38D-AABA3237B2D8"
    },
    {
      "item_id": "2CB279E7-CD79-1A21-9F32-89184886D7FC",
      "item_name": "Primordial",
      "item_type": "language_skill",
      "variable_name": "primordial",
      "essence_used": "63ABC96E-3804-4E1F-B38D-AABA3237B2D8"
    },
    {
      "item_id": "641E712F-1B60-C633-14BF-C4EE0DDD4AF4",
      "item_name": "Qini",
      "item_type": "language_skill",
      "variable_name": "qini",
      "essence_used": "63ABC96E-3804-4E1F-B38D-AABA3237B2D8"
    },
    {
      "item_id": "FBD22CAB-950F-8DAE-E052-65A88BF5205B",
      "item_name": "Sign Language",
      "item_type": "language_skill",
      "variable_name": "sign_language",
      "essence_used": "63ABC96E-3804-4E1F-B38D-AABA3237B2D8"
    },
    {
      "item_id": "D267CD08-6952-99E9-B19E-52EC690546BB",
      "item_name": "Sylvan",
      "item_type": "language_skill",
      "variable_name": "sylvan",
      "essence_used": "63ABC96E-3804-4E1F-B38D-AABA3237B2D8"
    },
    {
      "item_id": "EAC11C79-B399-7259-8556-8EDA88B7FCD8",
      "item_name": "Terran",
      "item_type": "language_skill",
      "variable_name": "terran",
      "essence_used": "63ABC96E-3804-4E1F-B38D-AABA3237B2D8"
    },
    {
      "item_id": "E76097FE-D47E-FD76-B7AF-8F0C40A3BCA1",
      "item_name": "Thieves Cant",
      "item_type": "language_skill",
      "variable_name": "thieves_cant",
      "essence_used": "63ABC96E-3804-4E1F-B38D-AABA3237B2D8"
    },
    {
      "item_id": "ABAE4F65-1A42-DEFC-21C8-11EBF883A484",
      "item_name": "Umbral",
      "item_type": "language_skill",
      "variable_name": "umbral",
      "essence_used": "63ABC96E-3804-4E1F-B38D-AABA3237B2D8"
    },
    {
      "item_id": "208E59A5-37B5-4DA3-97BE-8A1F540C94CD",
      "item_name": "Cymbals Skill",
      "item_type": "instrument_classification_skill",
      "variable_name": "cymbals",
      "essence_used": "72F93730-134F-4CA2-8FC4-F2915F20CAC6"
    },
    {
      "item_id": "F9134996-0370-34A2-A101-13497D6631A0",
      "item_name": "Drums Skill",
      "item_type": "instrument_classification_skill",
      "variable_name": "drums",
      "essence_used": "72F93730-134F-4CA2-8FC4-F2915F20CAC6"
    },
    {
      "item_id": "1DB53BE8-AB8F-CEB7-57E9-A3162F2AE4B3",
      "item_name": "Flutes Skill",
      "item_type": "instrument_classification_skill",
      "variable_name": "flutes",
      "essence_used": "72F93730-134F-4CA2-8FC4-F2915F20CAC6"
    },
    {
      "item_id": "3C5D9464-C206-44E7-015F-77A700D9BD9B",
      "item_name": "Harps Skill",
      "item_type": "instrument_classification_skill",
      "variable_name": "harps",
      "essence_used": "72F93730-134F-4CA2-8FC4-F2915F20CAC6"
    },
    {
      "item_id": "3B5FFB0D-26EF-B237-1F54-63CFF4004E02",
      "item_name": "Keyboards Skill",
      "item_type": "instrument_classification_skill",
      "variable_name": "keyboards",
      "essence_used": "72F93730-134F-4CA2-8FC4-F2915F20CAC6"
    },
    {
      "item_id": "7D2FFF31-8526-6AC0-42A7-BBCEBA432DBE",
      "item_name": "Horns Skill",
      "item_type": "instrument_classification_skill",
      "variable_name": "horns",
      "essence_used": "72F93730-134F-4CA2-8FC4-F2915F20CAC6"
    },
    {
      "item_id": "937D4758-2CD8-1DA4-E47D-7E0DFD4E9C06",
      "item_name": "Pipes Skill",
      "item_type": "instrument_classification_skill",
      "variable_name": "pipes",
      "essence_used": "72F93730-134F-4CA2-8FC4-F2915F20CAC6"
    },
    {
      "item_id": "1D54B02A-B9BF-B47F-A22B-25182CE551F0",
      "item_name": "Stringed, Bow Skill",
      "item_type": "instrument_classification_skill",
      "variable_name": "stringed_bow",
      "essence_used": "72F93730-134F-4CA2-8FC4-F2915F20CAC6"
    },
    {
      "item_id": "182CA00C-D9E4-C2AA-A243-B4EB4B8977B7",
      "item_name": "Stringed, Plucked Skill",
      "item_type": "instrument_classification_skill",
      "variable_name": "stringed_plucked",
      "essence_used": "72F93730-134F-4CA2-8FC4-F2915F20CAC6"
    },
    {
      "item_id": "F7FCBD40-CA99-88E6-BC5B-7D2F7D3C0EDB",
      "item_name": "Zithers Skill",
      "item_type": "instrument_classification_skill",
      "variable_name": "zithers",
      "essence_used": "72F93730-134F-4CA2-8FC4-F2915F20CAC6"
    },
    {
      "item_id": "45DE7B42-D548-498A-B7AB-C3DC1C660E57",
      "item_name": "Natural Weapon Skill",
      "item_type": "weapon_skill",
      "variable_name": "natural_weapon_skill",
      "essence_used": "22918408-67CC-4093-80E8-BF6FA8915C21"
    },
    {
      "item_id": "7BB6F92D-9C9F-D3D1-80FF-BBDBA3D06017",
      "item_name": "One-Handed Melee Weapon Skill",
      "item_type": "weapon_skill",
      "variable_name": "one_handed_melee_weapon_skill",
      "essence_used": "22918408-67CC-4093-80E8-BF6FA8915C21"
    },
    {
      "item_id": "8F94D454-48C2-A031-AED0-943ED5B609AF",
      "item_name": "Two-Handed Melee Weapon Skill",
      "item_type": "weapon_skill",
      "variable_name": "two_handed_melee_weapon_skill",
      "essence_used": "22918408-67CC-4093-80E8-BF6FA8915C21"
    },
    {
      "item_id": "2A16EE98-E160-89CD-4AC0-529BF36194D2",
      "item_name": "Archery Weapon Skill",
      "item_type": "weapon_skill",
      "variable_name": "archery_weapon_skill",
      "essence_used": "22918408-67CC-4093-80E8-BF6FA8915C21"
    },
    {
      "item_id": "850BDFE9-D36A-46AF-AD28-E1C533E140E3",
      "item_name": "Firearms Weapon Skill",
      "item_type": "weapon_skill",
      "variable_name": "firearms_weapon_skill",
      "essence_used": "22918408-67CC-4093-80E8-BF6FA8915C21"
    },
    {
      "item_id": "1A3033B2-1FA4-485A-9D0A-1CD0BC92C961",
      "item_name": "Throwable Weapon Skill",
      "item_type": "weapon_skill",
      "variable_name": "throwable_weapon_skill",
      "essence_used": "22918408-67CC-4093-80E8-BF6FA8915C21"
    },
    {
      "item_id": "F964C0DA-54EA-1EB5-ED00-8E9AD50FFA53",
      "item_name": "Bending Weapon Skill",
      "item_type": "weapon_skill",
      "variable_name": "bending_weapon_skill",
      "essence_used": "spellcasting_essence"
    },
    {
      "item_id": "937A5402-E933-4F87-8CAE-93427F47894A",
      "item_name": "Heavy Armor Skill",
      "item_type": "armor_skill",
      "variable_name": "heavy_armor_skill",
      "essence_used": "22918408-67CC-4093-80E8-BF6FA8915C21"
    },
    {
      "item_id": "44F9404E-77AC-1F60-68A4-4CD6AE071161",
      "item_name": "Light Armor Skill",
      "item_type": "armor_skill",
      "variable_name": "light_armor_skill",
      "essence_used": "22918408-67CC-4093-80E8-BF6FA8915C21"
    },
    {
      "item_id": "24495AD8-8EB9-488E-B816-5513E0A3DAA8",
      "item_name": "Medium Armor Skill",
      "item_type": "armor_skill",
      "variable_name": "medium_armor_skill",
      "essence_used": "22918408-67CC-4093-80E8-BF6FA8915C21"
    },
    {
      "item_id": "71E4E5C5-7AF6-9B16-90BF-8D9D6CCFD9DC",
      "item_name": "Natural Armor Skill",
      "item_type": "armor_skill",
      "variable_name": "natural_armor_skill",
      "essence_used": "22918408-67CC-4093-80E8-BF6FA8915C21"
    },
    {
      "item_id": "E973D6BE-E84E-4373-B134-BA8AA13BCD30",
      "item_name": "Shield Armor Skill",
      "item_type": "armor_skill",
      "variable_name": "shield_armor_skill",
      "essence_used": "22918408-67CC-4093-80E8-BF6FA8915C21"
    }
  ],
  "SkillTier": [
    {
      "item_name": "Skill Tier 0",
      "item_type": "skill_tier",
      "variable_name": "skill_tier_0",
      "skill_roll": "DIS",
      "skill_roll_dice": 0,
      "skill_roll_die": 0,
      "requires_skill_tier": "requires_skill_tier_0",
      "sp_required": 0,
      "skill_tier_level": 0,
      "pl_gp_value": 0
    },
    {
      "item_name": "Skill Tier 1",
      "item_type": "skill_tier",
      "variable_name": "skill_tier_1",
      "skill_roll": "d4",
      "skill_roll_dice": 1,
      "skill_roll_die": 4,
      "requires_skill_tier": "requires_skill_tier_1",
      "sp_required": 1,
      "skill_tier_level": 1,
      "pl_gp_value": 1000
    },
    {
      "item_name": "Skill Tier 2",
      "item_type": "skill_tier",
      "variable_name": "skill_tier_2",
      "skill_roll": "d5",
      "skill_roll_dice": 1,
      "skill_roll_die": 5,
      "requires_skill_tier": "requires_skill_tier_2",
      "sp_required": 4,
      "skill_tier_level": 2,
      "pl_gp_value": 4000
    },
    {
      "item_name": "Skill Tier 3",
      "item_type": "skill_tier",
      "variable_name": "skill_tier_3",
      "skill_roll": "d6",
      "skill_roll_dice": 1,
      "skill_roll_die": 6,
      "requires_skill_tier": "requires_skill_tier_3",
      "sp_required": 7,
      "skill_tier_level": 3,
      "pl_gp_value": 7000
    },
    {
      "item_name": "Skill Tier 4",
      "item_type": "skill_tier",
      "variable_name": "skill_tier_4",
      "skill_roll": "d7",
      "skill_roll_dice": 1,
      "skill_roll_die": 7,
      "requires_skill_tier": "requires_skill_tier_4",
      "sp_required": 10,
      "skill_tier_level": 4,
      "pl_gp_value": 10000
    },
    {
      "item_name": "Skill Tier 5",
      "item_type": "skill_tier",
      "variable_name": "skill_tier_5",
      "skill_roll": "d8",
      "skill_roll_dice": 1,
      "skill_roll_die": 8,
      "requires_skill_tier": "requires_skill_tier_5",
      "sp_required": 13,
      "skill_tier_level": 5,
      "pl_gp_value": 13000
    },
    {
      "item_name": "Skill Tier 6",
      "item_type": "skill_tier",
      "variable_name": "skill_tier_6",
      "skill_roll": "d9",
      "skill_roll_dice": 1,
      "skill_roll_die": 9,
      "requires_skill_tier": "requires_skill_tier_6",
      "sp_required": 16,
      "skill_tier_level": 6,
      "pl_gp_value": 16000
    },
    {
      "item_name": "Skill Tier 7",
      "item_type": "skill_tier",
      "variable_name": "skill_tier_7",
      "skill_roll": "d10",
      "skill_roll_dice": 1,
      "skill_roll_die": 10,
      "requires_skill_tier": "requires_skill_tier_7",
      "sp_required": 19,
      "skill_tier_level": 7,
      "pl_gp_value": 19000
    },
    {
      "item_name": "Skill Tier 8",
      "item_type": "skill_tier",
      "variable_name": "skill_tier_8",
      "skill_roll": "d11",
      "skill_roll_dice": 1,
      "skill_roll_die": 11,
      "requires_skill_tier": "requires_skill_tier_8",
      "sp_required": 22,
      "skill_tier_level": 8,
      "pl_gp_value": 22000
    },
    {
      "item_name": "Skill Tier 9",
      "item_type": "skill_tier",
      "variable_name": "skill_tier_9",
      "skill_roll": "d12",
      "skill_roll_dice": 1,
      "skill_roll_die": 12,
      "requires_skill_tier": "requires_skill_tier_9",
      "sp_required": 25,
      "skill_tier_level": 9,
      "pl_gp_value": 25000
    },
    {
      "item_name": "Skill Tier 10",
      "item_type": "skill_tier",
      "variable_name": "skill_tier_10",
      "skill_roll": "d13",
      "skill_roll_dice": 1,
      "skill_roll_die": 13,
      "requires_skill_tier": "requires_skill_tier_10",
      "sp_required": 28,
      "skill_tier_level": 10,
      "pl_gp_value": 28000
    },
    {
      "item_name": "Skill Tier 11",
      "item_type": "skill_tier",
      "variable_name": "skill_tier_11",
      "skill_roll": "d14",
      "skill_roll_dice": 1,
      "skill_roll_die": 14,
      "requires_skill_tier": "requires_skill_tier_11",
      "sp_required": 40,
      "skill_tier_level": 11,
      "pl_gp_value": 40000
    },
    {
      "item_name": "Skill Tier 12",
      "item_type": "skill_tier",
      "variable_name": "skill_tier_12",
      "skill_roll": "d15",
      "skill_roll_dice": 1,
      "skill_roll_die": 15,
      "requires_skill_tier": "requires_skill_tier_12",
      "sp_required": 50,
      "skill_tier_level": 12,
      "pl_gp_value": 50000
    },
    {
      "item_name": "Skill Tier 13",
      "item_type": "skill_tier",
      "variable_name": "skill_tier_13",
      "skill_roll": "d16",
      "skill_roll_dice": 1,
      "skill_roll_die": 16,
      "requires_skill_tier": "requires_skill_tier_13",
      "sp_required": 60,
      "skill_tier_level": 13,
      "pl_gp_value": 60000
    },
    {
      "item_name": "Skill Tier 14",
      "item_type": "skill_tier",
      "variable_name": "skill_tier_14",
      "skill_roll": "d17",
      "skill_roll_dice": 1,
      "skill_roll_die": 17,
      "requires_skill_tier": "requires_skill_tier_14",
      "sp_required": 80,
      "skill_tier_level": 14,
      "pl_gp_value": 80000
    },
    {
      "item_name": "Skill Tier 15",
      "item_type": "skill_tier",
      "variable_name": "skill_tier_15",
      "skill_roll": "d18",
      "skill_roll_dice": 1,
      "skill_roll_die": 18,
      "requires_skill_tier": "requires_skill_tier_15",
      "sp_required": 100,
      "skill_tier_level": 15,
      "pl_gp_value": 100000
    },
    {
      "item_name": "Skill Tier 16",
      "item_type": "skill_tier",
      "variable_name": "skill_tier_16",
      "skill_roll": "d19",
      "skill_roll_dice": 1,
      "skill_roll_die": 19,
      "requires_skill_tier": "requires_skill_tier_16",
      "sp_required": 120,
      "skill_tier_level": 16,
      "pl_gp_value": 120000
    },
    {
      "item_name": "Skill Tier 17",
      "item_type": "skill_tier",
      "variable_name": "skill_tier_17",
      "skill_roll": "d20",
      "skill_roll_dice": 1,
      "skill_roll_die": 20,
      "requires_skill_tier": "requires_skill_tier_17",
      "sp_required": 140,
      "skill_tier_level": 17,
      "pl_gp_value": 140000
    },
    {
      "item_name": "Skill Tier 18",
      "item_type": "skill_tier",
      "variable_name": "skill_tier_18",
      "skill_roll": "d21",
      "skill_roll_dice": 1,
      "skill_roll_die": 21,
      "requires_skill_tier": "requires_skill_tier_18",
      "sp_required": 160,
      "skill_tier_level": 18,
      "pl_gp_value": 160000
    },
    {
      "item_name": "Skill Tier 19",
      "item_type": "skill_tier",
      "variable_name": "skill_tier_19",
      "skill_roll": "d22",
      "skill_roll_dice": 1,
      "skill_roll_die": 22,
      "requires_skill_tier": "requires_skill_tier_19",
      "sp_required": 180,
      "skill_tier_level": 19,
      "pl_gp_value": 180000
    },
    {
      "item_name": "Skill Tier 20",
      "item_type": "skill_tier",
      "variable_name": "skill_tier_20",
      "skill_roll": "d23",
      "skill_roll_dice": 1,
      "skill_roll_die": 23,
      "requires_skill_tier": "requires_skill_tier_20",
      "sp_required": 200,
      "skill_tier_level": 20,
      "pl_gp_value": 200000
    },
    {
      "item_name": "Skill Tier 21",
      "item_type": "skill_tier",
      "variable_name": "skill_tier_21",
      "skill_roll": "d24",
      "skill_roll_dice": 1,
      "skill_roll_die": 24,
      "requires_skill_tier": "requires_skill_tier_21",
      "sp_required": 220,
      "skill_tier_level": 21,
      "pl_gp_value": 220000
    },
    {
      "item_name": "Skill Tier 22",
      "item_type": "skill_tier",
      "variable_name": "skill_tier_22",
      "skill_roll": "d25",
      "skill_roll_dice": 1,
      "skill_roll_die": 25,
      "requires_skill_tier": "requires_skill_tier_22",
      "sp_required": 240,
      "skill_tier_level": 22,
      "pl_gp_value": 240000
    },
    {
      "item_name": "Skill Tier 23",
      "item_type": "skill_tier",
      "variable_name": "skill_tier_23",
      "skill_roll": "d26",
      "skill_roll_dice": 1,
      "skill_roll_die": 26,
      "requires_skill_tier": "requires_skill_tier_23",
      "sp_required": 260,
      "skill_tier_level": 23,
      "pl_gp_value": 260000
    },
    {
      "item_name": "Skill Tier 24",
      "item_type": "skill_tier",
      "variable_name": "skill_tier_24",
      "skill_roll": "d27",
      "skill_roll_dice": 1,
      "skill_roll_die": 27,
      "requires_skill_tier": "requires_skill_tier_24",
      "sp_required": 280,
      "skill_tier_level": 24,
      "pl_gp_value": 280000
    }
  ],
  "Language": [
    {
      "item_id": "7C713184-C2B3-2270-2ADA-1B3C47CF2FFE",
      "item_name": "Abolian",
      "item_type": "language",
      "variable_name": "abolian"
    },
    {
      "item_id": "11797B93-B552-807F-C1D7-B75DAB51EC34",
      "item_name": "Abyssal",
      "item_type": "language",
      "variable_name": "abyssal"
    },
    {
      "item_id": "77AC72F7-688C-093D-1E29-067C8ECDC548",
      "item_name": "Aquan",
      "item_type": "language",
      "variable_name": "aquan"
    },
    {
      "item_id": "D31BAE4B-F984-13F2-537D-156D07F2F7BE",
      "item_name": "Auran",
      "item_type": "language",
      "variable_name": "auran"
    },
    {
      "item_id": "9CE184D4-669F-C2FC-1FA3-F6D3E55561A0",
      "item_name": "Common",
      "item_type": "language",
      "variable_name": "common"
    },
    {
      "item_id": "CE922467-93C7-3589-86B8-B5C1B12F24DB",
      "item_name": "Domir",
      "item_type": "language",
      "variable_name": "domir"
    },
    {
      "item_id": "F3DD13A6-DBA1-104A-E16D-78CD3513E97C",
      "item_name": "Draconic",
      "item_type": "language",
      "variable_name": "draconic"
    },
    {
      "item_id": "F968E89D-C2FF-FA26-951F-02587238161A",
      "item_name": "Druidic",
      "item_type": "language",
      "variable_name": "druidic"
    },
    {
      "item_id": "16F6B377-200C-3FBC-966B-6E9B957A2119",
      "item_name": "Dwarvish",
      "item_type": "language",
      "variable_name": "dwarvish"
    },
    {
      "item_id": "3BDE75C8-41C3-6DE0-8CDC-388ED5D89670",
      "item_name": "Elvish",
      "item_type": "language",
      "variable_name": "elvish"
    },
    {
      "item_id": "48655553-071F-29AC-071F-E7E9E4D53235",
      "item_name": "Enochian",
      "item_type": "language",
      "variable_name": "enochian"
    },
    {
      "item_id": "16F6B377-200C-3FBC-966B-6E9B957A2110",
      "item_name": "Gnomish",
      "item_type": "language",
      "variable_name": "gnomish"
    },
    {
      "item_id": "DFCE3528-A8AF-ACFF-B837-7A89B1E85FB3",
      "item_name": "Grel",
      "item_type": "language",
      "variable_name": "grel"
    },
    {
      "item_id": "EA0C0C09-5B81-A5E2-D325-82330B54A196",
      "item_name": "Ignan",
      "item_type": "language",
      "variable_name": "ignan"
    },
    {
      "item_id": "03E06BE0-F073-0D9B-E804-A9F014FAFF07",
      "item_name": "Infernal",
      "item_type": "language",
      "variable_name": "infernal"
    },
    {
      "item_id": "3FB72788-E5FE-2B64-2D1F-2A14BCC6284E",
      "item_name": "Nagh",
      "item_type": "language",
      "variable_name": "nagh"
    },
    {
      "item_id": "2AC81DE7-B375-9903-CABB-72BAFF74589B",
      "item_name": "Orcish",
      "item_type": "language",
      "variable_name": "orcish"
    },
    {
      "item_id": "305B9EAE-E108-C9EE-D31A-475F75AA3380",
      "item_name": "Primordial",
      "item_type": "language",
      "variable_name": "primordial"
    },
    {
      "item_id": "32E190D7-0A38-4071-81F7-0EC82089CCD4",
      "item_name": "Qini",
      "item_type": "language",
      "variable_name": "qini"
    },
    {
      "item_id": "E2528842-8503-6034-9AE2-1C28C1893A22",
      "item_name": "Sign Language",
      "item_type": "language",
      "variable_name": "sign_language"
    },
    {
      "item_id": "62DCCEE7-C228-2081-F171-F49FA62120D2",
      "item_name": "Sylvan",
      "item_type": "language",
      "variable_name": "sylvan"
    },
    {
      "item_id": "AC7B499B-0F30-B16D-D924-183E9473BDE0",
      "item_name": "Terran",
      "item_type": "language",
      "variable_name": "terran"
    },
    {
      "item_id": "A1ECE347-CF64-8454-67CF-9CA8BDEBFD7D",
      "item_name": "Thieves Cant",
      "item_type": "language",
      "variable_name": "thieves_cant"
    },
    {
      "item_id": "E7039ED2-EA0E-4218-A3BF-931A63F983DA",
      "item_name": "Umbral",
      "item_type": "language",
      "variable_name": "umbral"
    }
  ],
  "LanguageSkill": [
    {
      "item_id": "A5B19883-CBDA-EC46-A859-96FF01651278",
      "item_name": "Abolian",
      "item_type": "language_skill",
      "variable_name": "abolian",
      "essence_used": "63ABC96E-3804-4E1F-B38D-AABA3237B2D8"
    },
    {
      "item_id": "B12FE4D0-480A-239A-DAF0-704850F5162D",
      "item_name": "Abyssal",
      "item_type": "language_skill",
      "variable_name": "abyssal",
      "essence_used": "63ABC96E-3804-4E1F-B38D-AABA3237B2D8"
    },
    {
      "item_id": "820AB0A3-F21A-3135-DB75-89DCDF09A9D0",
      "item_name": "Aquan",
      "item_type": "language_skill",
      "variable_name": "aquan",
      "essence_used": "63ABC96E-3804-4E1F-B38D-AABA3237B2D8"
    },
    {
      "item_id": "B1B5365D-2DE0-AA53-A729-AC28BF8C8D52",
      "item_name": "Auran",
      "item_type": "language_skill",
      "variable_name": "auran",
      "essence_used": "63ABC96E-3804-4E1F-B38D-AABA3237B2D8"
    },
    {
      "item_id": "81DADED4-7909-482A-BE32-76887642C172",
      "item_name": "Common",
      "item_type": "language_skill",
      "variable_name": "common",
      "essence_used": "63ABC96E-3804-4E1F-B38D-AABA3237B2D8"
    },
    {
      "item_id": "6EEF7655-4FC7-F5F4-0AB8-C31C31FEEDCD",
      "item_name": "Domir",
      "item_type": "language_skill",
      "variable_name": "domir",
      "essence_used": "63ABC96E-3804-4E1F-B38D-AABA3237B2D8"
    },
    {
      "item_id": "0700727F-6C9E-4631-1140-B57A8E442137",
      "item_name": "Draconic",
      "item_type": "language_skill",
      "variable_name": "draconic",
      "essence_used": "63ABC96E-3804-4E1F-B38D-AABA3237B2D8"
    },
    {
      "item_id": "94D1A00F-4795-B1DD-6981-6CE3364AF1B3",
      "item_name": "Druidic",
      "item_type": "language_skill",
      "variable_name": "druidic",
      "essence_used": "63ABC96E-3804-4E1F-B38D-AABA3237B2D8"
    },
    {
      "item_id": "5C346F0F-D58D-2859-92EB-A347FA56899E",
      "item_name": "Dwarvish",
      "item_type": "language_skill",
      "variable_name": "dwarvish",
      "essence_used": "63ABC96E-3804-4E1F-B38D-AABA3237B2D8"
    },
    {
      "item_id": "42728623-5523-5986-672E-9A9FE5DD35B5",
      "item_name": "Elvish",
      "item_type": "language_skill",
      "variable_name": "elvish",
      "essence_used": "63ABC96E-3804-4E1F-B38D-AABA3237B2D8"
    },
    {
      "item_id": "4A5172E6-6D97-3958-C65B-F0792A660B85",
      "item_name": "Enochian",
      "item_type": "language_skill",
      "variable_name": "enochian",
      "essence_used": "63ABC96E-3804-4E1F-B38D-AABA3237B2D8"
    },
    {
      "item_id": "3098C163-7B26-7757-24F1-129C467D5BDB",
      "item_name": "Gnomish",
      "item_type": "language_skill",
      "variable_name": "gnomish",
      "essence_used": "63ABC96E-3804-4E1F-B38D-AABA3237B2D8"
    },
    {
      "item_id": "6AB76ADB-22BC-904A-7D72-43FDCA112DD1",
      "item_name": "Grel",
      "item_type": "language_skill",
      "variable_name": "grel",
      "essence_used": "63ABC96E-3804-4E1F-B38D-AABA3237B2D8"
    },
    {
      "item_id": "4767BD78-9829-6FC9-BD4A-5855F322CEB7",
      "item_name": "Ignan",
      "item_type": "language_skill",
      "variable_name": "ignan",
      "essence_used": "63ABC96E-3804-4E1F-B38D-AABA3237B2D8"
    },
    {
      "item_id": "22CC3970-0458-63CA-3D69-82A746B9A5CD",
      "item_name": "Nagh",
      "item_type": "language_skill",
      "variable_name": "nagh",
      "essence_used": "63ABC96E-3804-4E1F-B38D-AABA3237B2D8"
    },
    {
      "item_id": "16A53E58-027B-DF11-6AC5-72CA13B6583A",
      "item_name": "Orcish",
      "item_type": "language_skill",
      "variable_name": "orcish",
      "essence_used": "63ABC96E-3804-4E1F-B38D-AABA3237B2D8"
    },
    {
      "item_id": "2CB279E7-CD79-1A21-9F32-89184886D7FC",
      "item_name": "Primordial",
      "item_type": "language_skill",
      "variable_name": "primordial",
      "essence_used": "63ABC96E-3804-4E1F-B38D-AABA3237B2D8"
    },
    {
      "item_id": "641E712F-1B60-C633-14BF-C4EE0DDD4AF4",
      "item_name": "Qini",
      "item_type": "language_skill",
      "variable_name": "qini",
      "essence_used": "63ABC96E-3804-4E1F-B38D-AABA3237B2D8"
    },
    {
      "item_id": "FBD22CAB-950F-8DAE-E052-65A88BF5205B",
      "item_name": "Sign Language",
      "item_type": "language_skill",
      "variable_name": "sign_language",
      "essence_used": "63ABC96E-3804-4E1F-B38D-AABA3237B2D8"
    },
    {
      "item_id": "D267CD08-6952-99E9-B19E-52EC690546BB",
      "item_name": "Sylvan",
      "item_type": "language_skill",
      "variable_name": "sylvan",
      "essence_used": "63ABC96E-3804-4E1F-B38D-AABA3237B2D8"
    },
    {
      "item_id": "EAC11C79-B399-7259-8556-8EDA88B7FCD8",
      "item_name": "Terran",
      "item_type": "language_skill",
      "variable_name": "terran",
      "essence_used": "63ABC96E-3804-4E1F-B38D-AABA3237B2D8"
    },
    {
      "item_id": "E76097FE-D47E-FD76-B7AF-8F0C40A3BCA1",
      "item_name": "Thieves Cant",
      "item_type": "language_skill",
      "variable_name": "thieves_cant",
      "essence_used": "63ABC96E-3804-4E1F-B38D-AABA3237B2D8"
    },
    {
      "item_id": "ABAE4F65-1A42-DEFC-21C8-11EBF883A484",
      "item_name": "Umbral",
      "item_type": "language_skill",
      "variable_name": "umbral",
      "essence_used": "63ABC96E-3804-4E1F-B38D-AABA3237B2D8"
    }
  ],
  "AoeType": [
    {
      "item_id": "C53BE2B6-07EA-4B3B-9664-1AD286C44AF9",
      "item_name": "Circle",
      "variable_name": "circle"
    },
    {
      "item_id": "0FEF0148-6B62-4601-A8A1-A5A1A22905D8",
      "item_name": "Cone",
      "variable_name": "cone"
    },
    {
      "item_id": "0DBFA54E-F921-4835-B159-2A4AEFA62408",
      "item_name": "Cube",
      "variable_name": "cube"
    },
    {
      "item_id": "E8B770D7-1BC3-4035-A29C-B99047884CC1",
      "item_name": "Cylinder",
      "variable_name": "cylinder"
    },
    {
      "item_id": "56D1C490-B589-4B17-889A-59D866E38D54",
      "item_name": "Line",
      "variable_name": "line"
    },
    {
      "item_id": "981032B8-4F0B-43C9-8D98-67C693E4DB42",
      "item_name": "Sphere",
      "variable_name": "sphere"
    },
    {
      "item_id": "3F14BF23-09A6-4C05-AFD9-EE0CCD2596A3",
      "item_name": "Square",
      "variable_name": "square"
    }
  ],
  "RollType": [
    {
      "item_id": "981477BF-20AC-B5B0-A9A9-A5CB4459884C",
      "item_name": "Challenge Roll Assistance Roll",
      "variable_name": "challenge_roll_assistance_roll",
      "roll_type_pl_multiplier": 1.5
    },
    {
      "item_id": "82BBB3B6-4646-48E8-A5A2-8DC0947A91D0",
      "item_name": "Damage Roll",
      "variable_name": "damage_roll",
      "roll_type_pl_multiplier": 1
    },
    {
      "item_id": "ED5B44EA-7438-9582-A388-04EFF342E460",
      "item_name": "DC Roll",
      "variable_name": "dc_roll",
      "roll_type_pl_multiplier": 0.4
    },
    {
      "item_id": "AD80D31D-898B-66CE-0894-1335D11B1529",
      "item_name": "Contesting Roll",
      "variable_name": "contesting_roll",
      "roll_type_pl_multiplier": 0.4
    },
    {
      "item_id": "A063F21A-02D9-BA39-9C71-09C8E8122693",
      "item_name": "Essence Roll",
      "variable_name": "essence_roll",
      "roll_type_pl_multiplier": 0.4
    },
    {
      "item_id": "4FB7452A-F130-40C3-83E6-5E92C329D7B2",
      "item_name": "Healing Roll",
      "variable_name": "healing_roll",
      "roll_type_pl_multiplier": 1
    },
    {
      "item_id": "52949AF2-7C18-4BA3-754E-4BF898A67AFD",
      "item_name": "Recharge Ability Roll",
      "variable_name": "recharge_ability_roll",
      "roll_type_pl_multiplier": 1
    },
    {
      "item_id": "28B4E29C-5D8D-57CC-7634-761CEBD01190",
      "item_name": "Reduce Damage Roll",
      "variable_name": "reduce_damage_roll",
      "roll_type_pl_multiplier": 1
    },
    {
      "item_id": "9909BE44-99AE-8780-BB12-BD99BA6E672E",
      "item_name": "Regeneration Roll",
      "variable_name": "regeneration_roll",
      "roll_type_pl_multiplier": 1
    },
    {
      "item_id": "E26FC164-16F5-E38B-66F9-337FAEDE2A67",
      "item_name": "Skill Roll Assistance Roll",
      "variable_name": "skill_roll_assistance_roll",
      "roll_type_pl_multiplier": 1.5
    },
    {
      "item_id": "73ECB998-6C8E-1854-FBBB-EF02AC2AC0EE",
      "item_name": "Skill Roll Retracting Roll",
      "variable_name": "skill_roll_retracting_roll",
      "roll_type_pl_multiplier": 1.5
    },
    {
      "item_id": "5740CA49-006E-A7A0-B46B-6DDED6CD546C",
      "item_name": "Spell Melee Attack Roll",
      "variable_name": "spell_melee_attack_roll",
      "roll_type_pl_multiplier": 0.4
    },
    {
      "item_id": "DD280A3B-6F1D-4CE9-9EFD-505A74D0C07C",
      "item_name": "Spell Ranged Attack Roll",
      "variable_name": "spell_ranged_attack_roll",
      "roll_type_pl_multiplier": 0.4
    },
    {
      "item_id": "E5016E3A-6A12-2287-5F48-5CFAC863E967",
      "item_name": "Summon Roll",
      "variable_name": "summon_roll",
      "roll_type_pl_multiplier": 1
    },
    {
      "item_id": "4634635E-4E82-DFB3-8411-27A6BFB8CF0F",
      "item_name": "Temporary Vitality Regeneration Roll",
      "variable_name": "temporary_vitality_regeneration_roll",
      "roll_type_pl_multiplier": 1
    },
    {
      "item_id": "5E2689A2-0F7D-1E27-F4D5-CA09CA5C2591",
      "item_name": "Temporary Vitality Roll",
      "variable_name": "temporary_vitality_roll",
      "roll_type_pl_multiplier": 1
    },
    {
      "item_id": "1EBE0C5D-4D59-F08A-B118-13286A198ED5",
      "item_name": "Weapon Attack Roll Assistance Roll",
      "variable_name": "weapon_attack_roll_assistance_roll",
      "roll_type_pl_multiplier": 1
    },
    {
      "item_id": "2FE8DFB7-FE61-4862-AF71-3523262350A0",
      "item_name": "Weapon Melee Attack Roll",
      "variable_name": "weapon_melee_attack_roll",
      "roll_type_pl_multiplier": 0.4
    },
    {
      "item_id": "3F85CA97-F9B2-A83A-FDE8-E523FD99346C",
      "item_name": "Weapon Ranged Attack Roll",
      "variable_name": "weapon_ranged_attack_roll",
      "roll_type_pl_multiplier": 0.4
    },
    {
      "item_id": "9C752002-0C85-40D8-8DC0-D43AECBB2207",
      "item_name": "Armor Bending Roll",
      "variable_name": "armor_bending_roll",
      "roll_type_pl_multiplier": 1
    },
    {
      "item_id": "5DFD335C-B12A-4B3C-9FF6-560E12D9045F",
      "item_name": "Dying Stratum Roll",
      "variable_name": "dying_stratum_roll",
      "roll_type_pl_multiplier": 1
    },
    {
      "item_id": "FA17A3A2-3068-C84C-1EA5-C511F71FBD8B",
      "item_name": "Gathering Roll",
      "variable_name": "gathering_roll",
      "roll_type_pl_multiplier": 1
    },
    {
      "item_id": "54DC30E0-923C-4BBF-A8CC-570B0068E8A2",
      "item_name": "Crafting Roll",
      "variable_name": "crafting_roll",
      "roll_type_pl_multiplier": 1
    },
    {
      "item_id": "E1C8D281-0DC7-4883-8381-5630E23AD99D",
      "item_name": "Excavation Roll",
      "variable_name": "excavation_roll",
      "roll_type_pl_multiplier": 1
    },
    {
      "item_id": "77A044B7-7041-CA96-3C63-BB718B15A364",
      "item_name": "Damage Over Time Roll",
      "variable_name": "damage_over_time_roll",
      "roll_type_pl_multiplier": 1.3
    },
    {
      "item_id": "9878714A-27C3-D737-88B3-E8C1EE63A20F",
      "item_name": "Extra Damage Roll",
      "variable_name": "extra_damage_roll",
      "roll_type_pl_multiplier": 1
    },
    {
      "item_id": "42A38751-5549-CDE7-528E-AED309A2B07D",
      "item_name": "Extra Weapon Damage Roll",
      "variable_name": "extra_weapon_damage_roll",
      "roll_type_pl_multiplier": 1
    },
    {
      "item_id": "ABF66E1E-DA79-4329-31FA-70D981032C06",
      "item_name": "Skill Roll",
      "variable_name": "skill_roll",
      "roll_type_pl_multiplier": 1
    },
    {
      "item_id": "F1CB1CCF-138F-0B16-266F-3AFE1AB8C73D",
      "item_name": "Extra Healing Roll",
      "variable_name": "extra_healing_roll",
      "roll_type_pl_multiplier": 1
    },
    {
      "item_id": "C823C739-A9DE-AA5A-07B8-CB67F578F880",
      "item_name": "Increase Luck Roll",
      "variable_name": "increase_luck_roll",
      "roll_type_pl_multiplier": 1
    },
    {
      "item_id": "DE5B6A74-0024-FFDB-C5C6-B0248D956515",
      "item_name": "Reduce Luck Roll",
      "variable_name": "reduce_luck_roll",
      "roll_type_pl_multiplier": 1
    },
    {
      "item_id": "DB30C685-3830-9AEA-D8FA-D92FEA762982",
      "item_name": "Increase Mana Roll",
      "variable_name": "increase_mana_roll",
      "roll_type_pl_multiplier": 1
    },
    {
      "item_id": "905613F5-A045-BC0A-3686-CD1EC15060C5",
      "item_name": "Reduce Mana Roll",
      "variable_name": "reduce_mana_roll",
      "roll_type_pl_multiplier": 1
    },
    {
      "item_id": "99DC3B29-702D-08D0-346E-AA4359EA1D82",
      "item_name": "Extra Damage Taken Roll",
      "variable_name": "extra_damage_roll_taken",
      "roll_type_pl_multiplier": 1
    },
    {
      "item_id": "CC2CEB6B-CEFB-481F-911A-A47A427D5EB2",
      "item_name": "Lockpicking Roll",
      "variable_name": "lockpicking_roll",
      "roll_type_pl_multiplier": 1
    },
    {
      "item_id": "5FC40097-3C6E-53ED-0947-486FCC6DE627",
      "item_name": "Mana Drain Roll",
      "variable_name": "mana_drain_roll",
      "roll_type_pl_multiplier": 1
    },
    {
      "item_id": "F5BC82EE-DBDF-4594-F850-0C49E4292AC7",
      "item_name": "Temporary Max Vitality Roll",
      "variable_name": "temporary_max_vitality_roll",
      "roll_type_pl_multiplier": 1
    },
    {
      "item_id": "67B41E3F-5BF3-33A0-B459-7B8768B71933",
      "item_name": "Training Roll",
      "variable_name": "training_roll",
      "roll_type_pl_multiplier": 1
    }
  ],
  "VitalityStatus": [
    {
      "item_id": "82788F70-EBEF-44C4-80E7-6622AD20DD60",
      "item_name": "Invigorated",
      "item_type": "vitality_status",
      "variable_name": "invigorated"
    },
    {
      "item_id": "FF30B76E-785D-2CAF-FC66-C131D0548808",
      "item_name": "Fresh",
      "item_type": "vitality_status",
      "variable_name": "fresh"
    },
    {
      "item_id": "658483AA-34DE-74E5-C974-E3E202C31CC7",
      "item_name": "Barely Wounded",
      "item_type": "vitality_status",
      "variable_name": "barely_wounded"
    },
    {
      "item_id": "C97076EF-FED9-19B4-D109-C22F9BC740E8",
      "item_name": "Wounded",
      "item_type": "vitality_status",
      "variable_name": "wounded"
    },
    {
      "item_id": "44B8792E-632E-2651-C666-67DFD181E92A",
      "item_name": "Bloodied",
      "item_type": "vitality_status",
      "variable_name": "bloodied"
    },
    {
      "item_id": "298BE1DD-2917-476E-D79C-92CF8C598926",
      "item_name": "Well-Bloodied",
      "item_type": "vitality_status",
      "variable_name": "well_bloodied"
    },
    {
      "item_id": "D5DE14C4-3194-87BC-D767-6D45BDD90552",
      "item_name": "On Death's Door",
      "item_type": "vitality_status",
      "variable_name": "on_deaths_door"
    },
    {
      "item_id": "8AE129AF-52D8-CCE8-706A-85767DB52740",
      "item_name": "Dying",
      "item_type": "vitality_status",
      "variable_name": "dying"
    },
    {
      "item_id": "9FEE2E8A-9CF7-D74D-5D16-B86C2603A1FA",
      "item_name": "Dead",
      "item_type": "vitality_status",
      "variable_name": "dead"
    }
  ],
  "TeamType": [
    {
      "item_id": "7DBEB6D4-D147-703A-022E-05B290BB95C3",
      "item_name": "Friend",
      "item_type": "team_type",
      "variable_name": "friend"
    },
    {
      "item_id": "9399856B-2132-7574-1684-91139A2831DD",
      "item_name": "Enemy",
      "item_type": "team_type",
      "variable_name": "enemy"
    },
    {
      "item_id": "BBF5D6A6-FB9B-E07D-0497-B60EC68D2EBD",
      "item_name": "Neutral",
      "item_type": "team_type",
      "variable_name": "neutral"
    }
  ]
}
